export default __webpack_public_path__ + "static/media/Bronze_2_Rank.751c985f.png";